import { makeStyles } from '@material-ui/core';

import { indigo } from 'shared/styles/colors';

export default makeStyles({
  root: {
    fontFamily: 'PP Object Sans',
    fontWeight: 'normal',
    fontSize: '0.75rem',
    lineHeight: '1rem',
  },
  message: {
    fontFamily: 'PP Object Sans',
    color: indigo['70'],
  },
});
